'use client';

import React, { FC } from 'react';
import styles from './CtaBanner.module.scss';

import { useInView } from 'react-intersection-observer';
import createAnimationArr from '@/src/lib/helpers/createAnimationArr';
import Wrapper from '@/src/components/ui/wrapper/Wrapper';
import NextImage from '@/src/components/ui/nextImage/NextImage';
import { ITheme } from '@/src/lib/types/themeInterface';
import ShopifyStoreButton from '@/src/components/ui/shopifyButton/ShopifyStoreButton';

type TPage = {
  theme: ITheme;
};

const heading = 'Imagine, Prompt, Launch';
const excerpt =
  'Everything in one theme. Create your store quickly and easily with built-in AI features designed to help you sell faster.';

const CtaBanner: FC<TPage> = ({ theme }) => {
  const { ref: inViewRef2, inView: inView2 } = useInView({
    triggerOnce: true,
    rootMargin: '-250px 0px 0px',
    threshold: 0,
  });

  return (
      <section className={styles.ctaBanner}>
        <div className={styles.ctaBanner__about}>
          <Wrapper>
            <div className={styles.ctaBanner__head} ref={inViewRef2}>
              <h2 className={`heading__2 ${styles.heading} ${inView2 && styles.animate__heading}`}>
                {createAnimationArr(heading, styles.word__wrapper, 0, 0.01)}
              </h2>
              <p className={`excerpt ${styles.excerpt} ${inView2 && styles.animate__excerpt}`}>
                {createAnimationArr(excerpt, styles.word__wrapper, 0.1, 0.01)}
              </p>
              <div className={styles.ctaBanner__buttons}>
                <ShopifyStoreButton isWhite={true} theme={theme}/>
              </div>
            </div>
          </Wrapper>
        </div>

        <div className={styles.ctaBanner__gallery}>
          <div className={`${styles.ctaBanner__galleryColumn} ${styles.ctaBanner__galleryColumnLeft}`}/>
          <div className={`${styles.ctaBanner__galleryColumn} ${styles.ctaBanner__galleryColumnRight}`}/>
        </div>

        <div className={styles.ctaBanner__scroller}>
          <div className={`${styles.ctaBanner__scrollerColumn} ${styles.ctaBanner__scrollerColumnLeft}`}/>
          <div className={`${styles.ctaBanner__scrollerColumn} ${styles.ctaBanner__scrollerColumnRight}`}/>
        </div>
      </section>
  );
};

export default CtaBanner;
